<div class="w-full flex justify-end pt-5 pr-5">
  <button type="button" app-icon-button dialogClose class="p-0!">
    <svg-icon class="h-8 w-8 select-none" src="assets/icons/icon-close-fine.svg"></svg-icon>
  </button>
</div>
@let banners = banners$ | async;
@if (banners) {
  <div
    app-modal-content
    class="min-h-[33vh] flex flex-col gap-4 justify-center"
    [ngClass]="{ 'w-[80vw] max-w-[120rem]': banners.length > 1 }"
  >
    <div #carousel class="flex gap-4 no-scrollbar p-4 overflow-x-hidden">
      @for (banner of banners; track $index) {
        <app-card (click)="onNavigate($index)" (mousedown)="onLock()" (mouseup)="onUnlock()">
          <div app-card-content class="p-3! pb-6! h-fit w-[70vw] max-w-[100rem]">
            @if (banner.url) {
              <a class="group flex h-full overflow-hidden rounded-xl" [href]="banner.url" [target]="banner.target">
                <img
                  class="w-full group-hover:scale-105 duration-300 transition group-active:brightness-110 rounded-xl h-full object-cover"
                  loading="lazy"
                  [src]="banner.imagem"
                  [alt]="banner.titulo"
                />
              </a>
            } @else {
              <img
                class="w-full rounded-xl h-full object-cover"
                loading="lazy"
                [src]="banner.imagem"
                [alt]="banner.titulo"
              />
            }
          </div>
        </app-card>
      } @empty {
        @if (loading()) {
          <div class="flex gap-4 w-full animate-pulse">
            <app-skeleton class="w-[70vw] max-w-[100rem] h-48! rounded-xl"></app-skeleton>
          </div>
        } @else {
          <app-jumbotron class="min-h-[25vh]" translate> geral.nenhum-dado </app-jumbotron>
        }
      }
    </div>

    @if (banners.length > 1) {
      <div class="flex gap-4 justify-center">
        @for (banner of banners; track $index) {
          <div
            class="w-4 h-4 rounded-full bg-base-gray-light-700 cursor-pointer transition duration-300"
            [ngClass]="{ 'w-15 bg-base-post-notice-light!': current() === $index }"
            (click)="onNavigate($index)"
            (mousedown)="onLock()"
            (mouseup)="onUnlock()"
          ></div>
        }
      </div>
    }
  </div>
} @else {
  <div app-modal-content class="min-h-[33vh] w-[80vw] flex flex-col gap-4 justify-center">
    <app-skeleton class="!h-[33vh]"></app-skeleton>
  </div>
}
